import Skeleton from "react-loading-skeleton";
import { Divider } from "@/components/catalyst/Divider";
import { Heading, Subheading } from "@/components/catalyst/Heading";

export function SubscriptionSettingsSkeleton() {
	return (
		<div className="space-y-6">
			<div>
				<Heading>Subscription</Heading>
				<Subheading>Manage your subscription and view usage.</Subheading>
			</div>

			<Divider />

			{/* Current Plan Card Skeleton */}
			<div className="p-6 rounded-xl border border-base-content/10 bg-base-200/50">
				<div className="flex items-start justify-between">
					<div className="flex items-center gap-3">
						<Skeleton width={40} height={40} borderRadius={8} />
						<div>
							<div className="flex items-center gap-2 mb-1">
								<Skeleton width={120} height={24} />
								<Skeleton width={60} height={20} borderRadius={9999} />
							</div>
							<Skeleton width={180} height={16} />
						</div>
					</div>
					<Skeleton width={120} height={36} borderRadius={8} />
				</div>
			</div>

			{/* Usage Section Skeleton */}
			<div>
				<Heading level={3} className="mb-4">
					Current Usage
				</Heading>
				<div className="grid grid-cols-2 md:grid-cols-4 gap-4">
					{Array.from({ length: 4 }).map((_, index) => (
						<UsageCardSkeleton key={index} />
					))}
				</div>
			</div>
		</div>
	);
}

function UsageCardSkeleton() {
	return (
		<div className="p-4 rounded-lg border border-base-content/10 bg-base-100">
			<div className="flex items-center justify-between mb-2">
				<Skeleton width={80} height={16} />
				<Skeleton width={16} height={16} circle />
			</div>
			<div className="flex items-baseline gap-1">
				<Skeleton width={40} height={28} />
				<Skeleton width={30} height={14} />
			</div>
			<div className="mt-2">
				<Skeleton height={6} borderRadius={9999} />
			</div>
		</div>
	);
}
